import React from "react";
import ReactDOM from "react-dom";
import { UPLOAD_ICON } from "../../../utills/image-constant";

const UploadModel = ({
  modalOpen,
  loading,
  setModalOpen,
  uploadApi,
  setUploadApi,
  handlebulkupload,
  selectedFileName,
  setModelData,
  setSubDimensionList,
  setDimensionList,
}) => {
  if (!modalOpen) return null; // don't render unless open

  const handleClose = () => {
    setModalOpen(false);
    setUploadApi(false);
    setModelData && setModelData([]);
    setSubDimensionList && setSubDimensionList([]);
    setDimensionList && setDimensionList([]);
  };

  // This is the modal's actual JSX content
  const modalContent = (
    <div
      className="modal fade show"
      style={{
        display: "block",
        background: "rgba(0,0,0,0.5)",
        zIndex: 1060,
      }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header logout_header">
            <img src={UPLOAD_ICON} alt="Upload Icon" className="img-fluid" />
          </div>

          <div className="modal-body text-center">
            <h5>Are you sure you want to upload this file?</h5>
            <h6>{selectedFileName}</h6>
          </div>

          <div className="modal-footer logout_footer justify-content-center">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handlebulkupload}
              disabled={!uploadApi || loading}
            >
              {loading ? "Uploading..." : "OK"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  // ✅ This renders the modal above everything (normal Bootstrap behavior)
  return ReactDOM.createPortal(modalContent, document.body);
};

export default UploadModel;
